class Accordion {
    constructor(el) {
      this.accordion = el;
  
      el.accordion = this;
      this.accordionRows = el.querySelectorAll('.js--accordion-button');
      this.prepareAccordion();
    }
  
    prepareAccordion() {
      this.accordionRows.forEach(element => {
        element.addEventListener('click', () => this.toggleDrawer(element));
      });
    }
  
    toggleDrawer(element) {
      const drawerContent = element.nextElementSibling;
      const arrow = element.querySelector('.js--accordion-arrow ');
      console.log(element)
      if (drawerContent.classList.contains('hidden')) {
        drawerContent.classList.remove('hidden');
        drawerContent.setAttribute('aria-hidden', 'false');
        arrow.classList.add('rotated');
        element.setAttribute('aria-expanded', 'true');
      } else {
        drawerContent.classList.add('hidden');
        drawerContent.setAttribute('aria-hidden', 'true');
        arrow.classList.remove('rotated');
        element.setAttribute('aria-expanded', 'false');
      }
    }
  }
  
  export default Accordion;





